import { GcpRequestUploadFile } from '../../../../../../store/uploadStore';

export const getGcpUploadBytes = (uploads: GcpRequestUploadFile[]) => {
  const totalBytes = uploads.reduce((acc, { file }) => acc + file.size, 0);
  const uploadedBytes = uploads.reduce((acc, { uploadedSize }) => acc + uploadedSize, 0);

  return {
    uploadedBytes,
    totalBytes,
  };
};
